import { useState } from 'react';
import { useLocation } from 'wouter';
import { Lock, CheckCircle } from 'lucide-react';
import { api } from '../lib/api';

export default function ResetPassword() {
  const [, setLocation] = useLocation();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  // 从URL获取token
  const token = new URLSearchParams(window.location.search).get('token');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('两次输入的密码不一致');
      return;
    }

    if (password.length < 6) {
      setError('密码长度至少6位');
      return;
    }

    setLoading(true);

    try {
      await api.post('/auth/reset-password', { token, password });
      setSuccess(true);
    } catch (err: any) {
      setError(err.response?.data?.error || '重置失败,请重新申请');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="min-h-screen bg-[#1a2e3e] flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <div className="glass rounded-3xl p-8 text-center">
            <div className="w-20 h-20 rounded-full bg-green-500/20 flex items-center justify-center mx-auto mb-6">
              <CheckCircle className="w-10 h-10 text-green-400" />
            </div>
            <h2 className="text-2xl font-bold text-white mb-4">重置成功</h2>
            <p className="text-white/70 mb-8">
              您的密码已成功重置
              <br />
              请使用新密码登录
            </p>
            <button
              onClick={() => setLocation('/login')}
              className="w-full h-14 rounded-2xl bg-gradient-to-r from-[#22a9d9] to-[#6c5ce7] text-white font-medium hover:shadow-glow transition-shadow"
            >
              前往登录
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#1a2e3e] flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        {/* 标题 */}
        <div className="text-center mb-12">
          <div className="w-20 h-20 rounded-full bg-[#6c5ce7]/20 flex items-center justify-center mx-auto mb-6">
            <Lock className="w-10 h-10 text-[#6c5ce7]" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-3">重置密码</h1>
          <p className="text-white/60">
            请输入您的新密码
          </p>
        </div>

        {/* 表单 */}
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* 新密码 */}
          <div className="glass rounded-2xl p-4 flex items-center gap-3">
            <Lock className="w-5 h-5 text-white/40" />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="新密码(至少6位)"
              required
              className="flex-1 bg-transparent text-white placeholder-white/40 outline-none"
            />
          </div>

          {/* 确认密码 */}
          <div className="glass rounded-2xl p-4 flex items-center gap-3">
            <Lock className="w-5 h-5 text-white/40" />
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="确认新密码"
              required
              className="flex-1 bg-transparent text-white placeholder-white/40 outline-none"
            />
          </div>

          {/* 错误提示 */}
          {error && (
            <div className="bg-red-500/20 border border-red-500/50 rounded-2xl p-4 text-red-300 text-sm">
              {error}
            </div>
          )}

          {/* 提交按钮 */}
          <button
            type="submit"
            disabled={loading}
            className="w-full h-14 rounded-2xl bg-gradient-to-r from-[#22a9d9] to-[#6c5ce7] text-white font-medium hover:shadow-glow transition-shadow disabled:opacity-50"
          >
            {loading ? '重置中...' : '确认重置'}
          </button>
        </form>
      </div>
    </div>
  );
}
